/* eslint-disable */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardFooter,
} from "reactstrap";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import MultiStepProgressBar from "./MultiStepProgressBar";

import pageService from "../../service/page.service";
import styleService from "../../service/style.service";
import linkService from "../../service/link.service";
import scriptService from "../../service/script.service";

import useToast from "../../hooks/useToast";
import useInput from "../../hooks/useInput";

import styles from "./Form.module.css";
import "react-toastify/dist/ReactToastify.css";

const NewPageForm = () => {
  const getErrorMessage = (error) =>
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();

  const initialPageState = {
    title: "",
    description: "",
  };

  const initialLinkStyleState = {
    bgColor: "#EC2222",
    fontColor: "#ffffff",
    borderStyle: "40px",
    hoverBgColor: "#ffffff",
    hoverFontColor: "#EC2222",
  };

  const initialLinksState = {
    linkName: "",
    linkUrl: "",
  };

  const initialScriptState = {
    title: "",
    code: "",
    position: "head",
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [currentPageId, setCurrentPageId] = useState(0);
  const [avatar, setAvatar] = useState(null);
  const [cover, setCover] = useState(null);
  const [page, setPage] = useState(initialPageState);
  const [linkStyle, setLinkStyle] = useState(initialLinkStyleState);
  const [links, setLinks] = useState(initialLinksState);
  const [postedLinks, setPostedLinks] = useState([]);
  const [scripts, setScripts] = useState(initialScriptState);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const {
    postStyleToast,
    postPageToast,
    postImagesToast,
    postLinkToast,
    postScriptToast,
  } = useToast();

  const {
    handlePageChange,
    handleCoverChange,
    handleAvatarChange,
    handleLinkStyleChange,
    handleLinkChange,
    handleScriptChange,
  } = useInput({
    setPage,
    page,
    setCover,
    cover,
    setAvatar,
    avatar,
    setLinkStyle,
    linkStyle,
    setLinks,
    links,
    setScripts,
    scripts,
  });

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const _next = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    const newPage = {
      title: page.title,
      description: page.description,
    };

    try {
      if (currentStep === 1) {
        if (!page.title) {
          return setMessage("Insira um titulo");
        }
        setMessage("");
        if (!page.description) {
          return setMessage("Insira uma descrição");
        }
        setMessage("");

        const response = await pageService.postPage({ newPage, admin });
        const createdPageId = response?.data?.id;

        if (!createdPageId) {
          return setMessage("Não foi possível criar a página.");
        }

        setCurrentPageId(createdPageId);
        postPageToast();
      }

      if (currentStep === 2) {
        if (!avatar) {
          return setMessage("Selecione um avatar");
        }
        setMessage("");
        if (!cover) {
          return setMessage("Selecione uma capa");
        }
        setMessage("");
        if (!currentPageId) {
          return setMessage("ID da página inválido para upload.");
        }

        const coverData = new FormData();
        coverData.append("file", cover, cover.name);

        const avatarData = new FormData();
        avatarData.append("file", avatar, avatar.name);

        await pageService.postImages({
          admin,
          currentPageId,
          avatarData,
          coverData,
        });
        postImagesToast();
      }

      if (currentStep === 3) {
        const styleData = {
          bgColor: linkStyle.bgColor,
          fontColor: linkStyle.fontColor,
          borderStyle: linkStyle.borderStyle,
          hoverBgColor: linkStyle.hoverBgColor,
          hoverFontColor: linkStyle.hoverFontColor,
        };

        await styleService.postStyle({ admin, styleData, currentPageId });
        postStyleToast();
      }

      const currStep = currentStep >= 4 ? 5 : currentStep + 1;
      setCurrentStep(currStep);
    } catch (error) {
      setMessage(getErrorMessage(error));
    }
  };

  const handleNewScript = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = currentPageId;

    if (!scripts.title) {
      return setMessage("Insira o nome do Script");
    }
    setMessage("");
    if (!scripts.code) {
      return setMessage("Insira o código do Script");
    }
    const script = {
      title: scripts.title,
      code: scripts.code,
      position: scripts.position,
    };

    scriptService
      .postScript({ admin, script, idId })
      .then(postScriptToast)
      .then(setScripts({ ...scripts, title: "", code: "" }));
  };

  const handleNewLink = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    if (!links.linkName) {
      return setMessage("Insira um nome");
    }
    setMessage("");
    if (!links.linkUrl) {
      return setMessage("Insira a URL");
    }
    const link = {
      title: links.linkName,
      url: links.linkUrl,
    };

    linkService
      .postLink({ currentPageId, admin, link })
      .then(postLinkToast)
      .then(setLinks({ ...links, linkName: "", linkUrl: "" }))
      .then(setMessage(""));
  };

  const end = () => {
    navigate(-1);
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Card>
          <CardHeader className="centerr">
            <h3>Nova Página</h3>
          </CardHeader>
          <CardBody>
            <CardTitle>
              <MultiStepProgressBar currentStep={currentStep} />
            </CardTitle>
            <CardText />
            <Step1
              isEditing={false}
              stepTitle="Informações"
              currentStep={currentStep}
              handlePageChange={handlePageChange}
              title={page.title}
              description={page.description}
              isCreating={true}
            />
            {error && error}
            <Step2
              currentStep={currentStep}
              handleCoverChange={handleCoverChange}
              handleAvatarChange={handleAvatarChange}
              cover={cover}
              avatar={avatar}
              isCreating={true}
            />
            <Step3
              currentStep={currentStep}
              bgColor={linkStyle.bgColor}
              fontColor={linkStyle.fontColor}
              borderStyle={linkStyle.borderStyle}
              hoverBgColor={linkStyle.hoverBgColor}
              hoverFontColor={linkStyle.hoverFontColor}
              handleLinkStyleChange={handleLinkStyleChange}
              postedLinks={postedLinks}
              isCreating={true}
            />
            <Step4
              currentStep={currentStep}
              handleLinkChange={handleLinkChange}
              linkName={links.linkName}
              linkUrl={links.linkUrl}
              handleNewLink={handleNewLink}
              id={currentPageId}
              isCreating={true}
            />
            <Step5
              currentStep={currentStep}
              handleScriptChange={handleScriptChange}
              scriptName={scripts.title}
              scriptCode={scripts.code}
              scriptLocation={scripts.position}
              handleNewScript={handleNewScript}
              isCreating={true}
            />
          </CardBody>
          <CardFooter>
            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
            {currentStep < 5 && (
              <Button
                className={styles.button_form}
                color="primary float-right"
                onClick={_next}
              >
                Próximo
              </Button>
            )}
            {currentStep > 4 && (
              <Button
                onClick={end}
                className={styles.button_form}
                color=" float-right"
              >
                Finalizar
              </Button>
            )}
          </CardFooter>
        </Card>
      </Form>
    </>
  );
};

export default NewPageForm;
